import { useQuery } from '@tanstack/react-query';
import { configurationService } from 'commons/services';
import { PaymentMethodsType } from 'commons/types';
import { feePlansMapper } from '../utils/feePlansMapper';

const getPlanFeesByExternalId = async (externalId: string) => {
  const response = await configurationService.getPlanByExternalId(externalId);
  return feePlansMapper(response, [
    PaymentMethodsType.CreditCard,
    PaymentMethodsType.Ticket,
  ]);
};

export const useGetPlanFees = (externalId: string) => {
  return useQuery({
    queryKey: ['plan-fees', externalId],
    queryFn: () => getPlanFeesByExternalId(externalId),
  });
};
